import { IMAGES } from "@/data/catalog";

// Dedicated SEO landing pages. Original copy only — no invented prices, reviews,
// projects, licences or accreditations. Real published rates live in the Price Guide.

export const SEO_PAGES = [
  {
    slug: "hdb-renovation-singapore",
    title: "HDB Renovation Contractor Singapore",
    h1: "HDB Renovation Contractor in Singapore",
    description: "HDB-registered renovation contractor in Singapore for HDB flats — hacking, tiling, carpentry, plumbing, electrical and ceiling works with transparent, itemised pricing.",
    keywords: "HDB renovation contractor Singapore, HDB renovation Singapore, HDB renovation package",
    crumb: "HDB Renovation",
    image: IMAGES.residential1,
    serviceType: "HDB Renovation",
    intro:
      "WAAN METAL is an HDB-registered renovation contractor serving homeowners across Singapore. Whether you are renovating a new flat or refreshing a long-time home, we handle the full scope of permitted HDB renovation works — from hacking and tiling to carpentry, plumbing coordination and ceiling works — with clearly published, itemised rates.",
    covers: [
      "Whole-house and partial hacking & dismantling",
      "Floor and wall tiling, screeding and skirting",
      "Built-in carpentry, wardrobes and kitchen cabinets",
      "Plumbing and electrical works by licensed professionals",
      "False ceiling, cornices and partition works",
      "Painting, doors, windows and grille works",
    ],
    why: [
      "HDB-registered for permitted renovation works",
      "Transparent price list — no hidden markups",
      "In-house metal workshop for gates, grilles and custom works",
      "Single accountable team from quotation to handover",
    ],
    priceCats: ["Hacking & Dismantling", "Tiling", "Carpentry", "Plumbing", "Electrical", "Ceiling & Partition"],
    serviceLinks: [
      { label: "Residential Renovation", to: "/services/residential-renovation" },
      { label: "Kitchen Renovation", to: "/kitchen-renovation-singapore" },
      { label: "Bathroom Renovation", to: "/bathroom-renovation-singapore" },
    ],
    faqs: [
      { q: "Are you an HDB-registered renovation contractor?", a: "Yes. WAAN METAL operates as an HDB-registered renovation contractor. Registration covers permitted renovation works; regulated works require the relevant HDB and other approvals." },
      { q: "Do you provide an itemised HDB renovation price list?", a: "Yes — our full renovation price list is published and searchable on our Price Guide page, with rates for hacking, tiling, carpentry, plumbing, electrical and more." },
      { q: "How do I get an HDB renovation quotation?", a: "Submit our online quotation form with your flat type, scope and any photos. We review it, arrange a site assessment and issue a detailed quotation." },
    ],
  },
  {
    slug: "condo-renovation-singapore",
    title: "Condo Renovation Singapore",
    h1: "Condominium Renovation in Singapore",
    description: "Condominium renovation in Singapore by WAAN METAL — carpentry, tiling, ceiling and electrical works tailored to condo layouts and MCST requirements, with clear pricing.",
    keywords: "condo renovation Singapore, condominium renovation contractor Singapore",
    crumb: "Condo Renovation",
    image: IMAGES.residential2,
    serviceType: "Condominium Renovation",
    intro:
      "We renovate private condominiums and apartments across Singapore with finishes and workmanship suited to higher-specification homes. Our team coordinates around MCST rules, protection requirements and lift-access restrictions so your renovation runs smoothly from start to finish.",
    covers: [
      "Custom carpentry, wardrobes and feature joinery",
      "Premium tiling, stone and timber flooring coordination",
      "False ceiling, light coves and cornices",
      "Electrical, lighting and smart-home point wiring",
      "Interior design and space planning",
    ],
    why: [
      "Workmanship suited to condominium specifications",
      "MCST-aware scheduling and site protection",
      "Design-and-build under one roof",
      "Transparent, itemised pricing",
    ],
    priceCats: ["Carpentry", "Tiling", "Ceiling & Partition", "Electrical"],
    serviceLinks: [
      { label: "Residential Renovation", to: "/services/residential-renovation" },
      { label: "Interior Design", to: "/interior-design" },
      { label: "Kitchen Renovation", to: "/kitchen-renovation-singapore" },
    ],
    faqs: [
      { q: "Do you renovate private condominiums?", a: "Yes, we undertake condominium and apartment renovations across Singapore, coordinating with your MCST on protection and access requirements." },
      { q: "Can you handle design and build together?", a: "Yes — our interior design studio works directly with our renovation and fabrication teams so your design is built as drawn." },
    ],
  },
  {
    slug: "bto-resale-renovation-singapore",
    title: "HDB BTO & Resale Renovation Singapore",
    h1: "HDB BTO & Resale Renovation in Singapore",
    description: "BTO and resale HDB renovation in Singapore. Flexible tiling, hacking and carpentry packages for new BTO flats and older resale units, with published rates.",
    keywords: "BTO renovation Singapore, resale HDB renovation Singapore, BTO renovation package",
    crumb: "BTO & Resale Renovation",
    image: IMAGES.kitchen,
    serviceType: "HDB BTO and Resale Renovation",
    intro:
      "New BTO flats and older resale units need very different approaches. For BTO homes we offer flexible tiling where you can pay labour only and buy your own tiles, plus carpentry and built-ins. For resale flats we handle full hacking, re-tiling, re-wiring coordination and complete refurbishment.",
    covers: [
      "BTO flexible tiling — labour-only or full supply-and-lay",
      "Resale whole-house hacking & dismantling",
      "Carpentry, wardrobes and kitchen cabinetry",
      "Plumbing and electrical coordination",
      "Painting and finishing",
    ],
    why: [
      "Separate, honest BTO and resale pricing",
      "Buy-your-own-tiles option for BTO",
      "HDB-registered renovation contractor",
      "Clear scope, inclusions and exclusions",
    ],
    priceCats: ["HDB BTO Tiling", "Hacking & Dismantling", "Carpentry", "Tiling"],
    serviceLinks: [
      { label: "HDB Renovation", to: "/hdb-renovation-singapore" },
      { label: "Residential Renovation", to: "/services/residential-renovation" },
      { label: "Renovation Prices & Packages", to: "/renovation-packages-singapore" },
    ],
    faqs: [
      { q: "Do I need to hack a new BTO flat?", a: "Usually not. New BTO flats come tiled in some areas, so we offer flexible tiling where you can tile only where needed and even supply your own tiles." },
      { q: "What does resale flat renovation involve?", a: "Resale flats often need full hacking, re-tiling, carpentry replacement and re-wiring coordination. Our price list breaks these down by flat type." },
    ],
  },
  {
    slug: "kitchen-renovation-singapore",
    title: "Kitchen Renovation Singapore",
    h1: "Kitchen Renovation in Singapore",
    description: "Kitchen renovation in Singapore — cabinetry, tiling, plumbing and electrical works for HDB and condo kitchens, built in-house with transparent carpentry rates.",
    keywords: "kitchen renovation Singapore, kitchen cabinet Singapore, kitchen carpentry Singapore",
    crumb: "Kitchen Renovation",
    image: IMAGES.kitchen,
    serviceType: "Kitchen Renovation",
    intro:
      "A well-planned kitchen balances storage, workflow and durability. We design and build kitchens for HDB flats and condominiums — from top and bottom cabinets and tall units to tiling, sink bases, plumbing and electrical points — with carpentry rates published openly.",
    covers: [
      "Top, bottom and tall-boy kitchen cabinets",
      "Casement and drawer configurations with soft-close",
      "Kitchen wall and floor tiling",
      "Sink, tap and water-point plumbing",
      "Hood, hob and appliance electrical points",
    ],
    why: [
      "In-house carpentry for quality and schedule control",
      "Per-foot-run cabinet pricing published openly",
      "Durable laminate and finish options",
      "Coordinated plumbing and electrical",
    ],
    priceCats: ["Carpentry", "Tiling", "Plumbing", "Electrical"],
    serviceLinks: [
      { label: "HDB Renovation", to: "/hdb-renovation-singapore" },
      { label: "Residential Renovation", to: "/services/residential-renovation" },
      { label: "Renovation Prices & Packages", to: "/renovation-packages-singapore" },
    ],
    faqs: [
      { q: "How is kitchen carpentry priced?", a: "Kitchen cabinets are priced per foot run with options for casement doors, drawers and tall units. See the Carpentry section of our Price Guide for published rates." },
      { q: "Do you handle kitchen plumbing and electrical?", a: "Yes — sink and tap plumbing and appliance power points are carried out by licensed professionals and quoted alongside the carpentry." },
    ],
  },
  {
    slug: "bathroom-renovation-singapore",
    title: "Bathroom & Toilet Renovation Singapore",
    h1: "Bathroom & Toilet Renovation in Singapore",
    description: "Bathroom and toilet renovation in Singapore — overlay or hack-and-tile packages for two bathrooms, waterproofing, plumbing and electrical, with published package pricing.",
    keywords: "bathroom renovation Singapore, toilet renovation Singapore, bathroom renovation package",
    crumb: "Bathroom Renovation",
    image: IMAGES.residential1,
    serviceType: "Bathroom and Toilet Renovation",
    intro:
      "Bathrooms are the most waterproofing-sensitive rooms in any home. We offer two clear approaches for a pair of bathrooms — a faster overlay package and a full hack-and-tile package — each with waterproofing, plumbing, heater and electrical works included. Package pricing is published on our Price Guide.",
    covers: [
      "Overlay tiling (no hacking) for faster turnaround",
      "Full hack-and-tile with fresh waterproofing",
      "WC, basin, mixer and shower installation",
      "Instant or storage water-heater fit-out",
      "Bathroom electrical and lighting points",
    ],
    why: [
      "Two transparent, fixed-scope packages",
      "Proper waterproofing to reduce leaks",
      "Licensed plumbing with PUB submission where required",
      "Clear add-on pricing for upgrades",
    ],
    priceCats: ["Bathroom Renovation", "Tiling", "Plumbing"],
    serviceLinks: [
      { label: "HDB Renovation", to: "/hdb-renovation-singapore" },
      { label: "Residential Renovation", to: "/services/residential-renovation" },
      { label: "Renovation Prices & Packages", to: "/renovation-packages-singapore" },
    ],
    faqs: [
      { q: "Should I choose overlay or hack-and-tile?", a: "Overlay is faster and tidier when existing tiles are sound; hack-and-tile is recommended when you want fresh waterproofing or to change levels. Both packages are itemised on our Price Guide." },
      { q: "Is waterproofing included?", a: "Yes. Both bathroom packages include waterproofing appropriate to the method, with full scope listed in the package inclusions." },
    ],
  },
  {
    slug: "office-renovation-singapore",
    title: "Office Renovation Singapore",
    h1: "Office Renovation & Fit-Out in Singapore",
    description: "Office renovation and fit-out in Singapore by WAAN METAL — partitions, ceilings, flooring, electrical and interior design that work around your business operations.",
    keywords: "office renovation Singapore, office renovation contractor Singapore, office fit-out contractor Singapore, office interior design Singapore",
    crumb: "Office Renovation",
    image: IMAGES.commercial1,
    serviceType: "Office Renovation and Fit-Out",
    intro:
      "We fit out offices and workplaces across Singapore, balancing brand, function and compliance. From glass and drywall partitions to ceilings, flooring, electrical and data points, we schedule works around your operations to minimise downtime.",
    covers: [
      "Space planning and office interior design",
      "Glass and drywall partition systems",
      "Ceiling, lighting and flooring works",
      "Electrical, data and power-point wiring",
      "Meeting rooms, pantries and reception areas",
    ],
    why: [
      "Operations-friendly scheduling",
      "Design-and-build under one roof",
      "Compliance-aware execution",
      "Commercial works quoted per project",
    ],
    priceCats: ["Commercial Renovation", "Ceiling & Partition", "Electrical"],
    serviceLinks: [
      { label: "Commercial Renovation", to: "/commercial-renovation-singapore" },
      { label: "Commercial Services", to: "/services/commercial-renovation" },
      { label: "Interior Design", to: "/interior-design" },
    ],
    faqs: [
      { q: "Can you renovate while we keep working?", a: "Yes. We plan phased works and after-hours schedules where possible to keep your business running during the fit-out." },
      { q: "How is office renovation priced?", a: "Commercial fit-out is scoped and quoted per project after a site assessment. Request a quotation and we will itemise it for you." },
    ],
  },
  {
    slug: "commercial-renovation-singapore",
    title: "Commercial Renovation Contractor Singapore",
    h1: "Commercial Renovation Contractor in Singapore",
    description: "Commercial renovation contractor in Singapore for retail, F&B, showrooms and offices — fit-out, partitions, ceilings and refurbishment scoped and quoted per project.",
    keywords: "commercial renovation Singapore, commercial renovation contractor Singapore, commercial fit-out contractor Singapore, retail renovation Singapore",
    crumb: "Commercial Renovation",
    image: IMAGES.commercial2,
    serviceType: "Commercial Renovation",
    intro:
      "From retail shops and F&B outlets to showrooms and offices, we deliver commercial renovation and refurbishment that supports your brand and your customers. Our in-house metal workshop also lets us fabricate shopfronts, counters and custom fixtures.",
    covers: [
      "Retail, F&B and showroom renovation",
      "Office fit-out and refurbishment",
      "Glass and drywall partitions",
      "Ceiling, flooring and lighting works",
      "Custom metal shopfronts and fixtures",
    ],
    why: [
      "Multi-trade commercial contractor",
      "In-house metal fabrication",
      "Operations-friendly scheduling",
      "Per-project, transparent quotations",
    ],
    priceCats: ["Commercial Renovation", "Ceiling & Partition"],
    serviceLinks: [
      { label: "Office Renovation", to: "/office-renovation-singapore" },
      { label: "Commercial Services", to: "/services/commercial-renovation" },
      { label: "Metal Fabrication", to: "/metal-fabrication-singapore" },
    ],
    faqs: [
      { q: "What commercial spaces do you renovate?", a: "Offices, retail shops, restaurants and F&B outlets, showrooms and light-commercial units across Singapore." },
      { q: "Do you issue fixed commercial rates?", a: "Commercial works vary widely, so they are quoted per project after a site assessment rather than fixed-rate." },
    ],
  },
  {
    slug: "renovation-packages-singapore",
    title: "Renovation Prices & Packages Singapore",
    h1: "Renovation Prices & Packages in Singapore",
    description: "Transparent renovation prices and packages in Singapore — itemised rates for hacking, tiling, carpentry, plumbing, electrical, ceiling and bathroom packages. Browse the full price list.",
    keywords: "renovation price Singapore, renovation package Singapore, direct renovation contractor Singapore, renovation price list Singapore",
    crumb: "Renovation Prices & Packages",
    image: IMAGES.interior1,
    serviceType: "Renovation Pricing",
    intro:
      "We publish our renovation prices so you can plan with confidence. Browse itemised, management-approved rates across every trade — hacking, tiling, carpentry, plumbing, electrical, ceiling and partition — plus fixed-scope bathroom packages and renovation coordination fees. Commercial, industrial and custom metal works are quoted per project.",
    covers: [
      "Itemised labour and material rates by trade",
      "Fixed-scope bathroom renovation packages",
      "Whole-house hacking rates by flat type",
      "Carpentry priced per foot run",
      "Renovation coordination fixed fees",
    ],
    why: [
      "Published, searchable price list",
      "Clear units, inclusions and exclusions",
      "GST and PUB fees noted where applicable",
      "Every rate confirmed in a written quotation",
    ],
    priceCats: [],
    priceAll: true,
    serviceLinks: [
      { label: "View Full Price Guide", to: "/price-guide" },
      { label: "HDB Renovation", to: "/hdb-renovation-singapore" },
      { label: "Bathroom Renovation", to: "/bathroom-renovation-singapore" },
    ],
    faqs: [
      { q: "Are the published prices final?", a: "They are indicative and management-approved. Final pricing is confirmed in a written quotation after a site assessment, since scope and site conditions vary." },
      { q: "Do prices include GST?", a: "GST and PUB submission fees are noted against the relevant items. Your quotation will state the full breakdown." },
    ],
  },
  {
    slug: "metal-fabrication-singapore",
    title: "Metal Fabrication Singapore",
    h1: "Metal Fabrication & Metal Works in Singapore",
    description: "Metal fabrication in Singapore — stainless steel, mild steel and aluminium works, gates, grilles, staircases, handrails and custom components fabricated in-house.",
    keywords: "metal fabrication Singapore, metal works contractor Singapore, stainless steel fabrication Singapore, metal gates and grilles Singapore",
    crumb: "Metal Fabrication",
    image: IMAGES.gate1,
    serviceType: "Metal Fabrication",
    intro:
      "Our in-house metal workshop fabricates architectural, residential and industrial metalwork across Singapore. From stainless steel and mild steel to aluminium, we produce gates, grilles, staircases, handrails, platforms and custom components — fabricated, finished and installed to specification.",
    covers: [
      "Stainless steel and mild steel fabrication",
      "Metal gates, window and door grilles",
      "Staircases, handrails and balustrades",
      "Steel platforms and mezzanines",
      "Architectural and custom metal components",
      "Welding and metal repairs",
    ],
    why: [
      "In-house workshop for quality control",
      "Residential, commercial and industrial capability",
      "Custom-fabricated to your sizes and design",
      "Quoted per project after measurement",
    ],
    priceCats: ["Metal Gates & Grilles", "Stainless Steel Works", "Industrial Metal Works"],
    serviceLinks: [
      { label: "Metal Works & Fabrication", to: "/services/metal-works-fabrication" },
      { label: "Industrial Renovation", to: "/services/industrial-renovation" },
      { label: "Commercial Renovation", to: "/commercial-renovation-singapore" },
    ],
    faqs: [
      { q: "Do you fabricate custom metal gates and grilles?", a: "Yes. We custom-fabricate gates and grilles to your opening sizes and design, priced per set after measurement." },
      { q: "Can you handle industrial steel platforms?", a: "Yes — steel platforms, mezzanines and industrial fabrication are quoted per project, with regulated works subject to the required approvals." },
    ],
  },
];

export const seoPageBySlug = (slug) => SEO_PAGES.find((p) => p.slug === slug);
